// extracted by mini-css-extract-plugin
export default {"crossButton":"PhoneVerifyCodeModal_crossButton__2Meg+","modal":"PhoneVerifyCodeModal_modal__wsgkh"};